export function playSfx(path) {
    let sfx = new Audio(path);
    sfx.play();
}